import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PortfolioDashboardDisaptcher } from "./Variable";

export interface PortfolioDashboardStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: ClientAccount[];
}

export class PortfolioDashboardStoreStatic extends BaseStore<PortfolioDashboardStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(PortfolioDashboardDisaptcher, (actionData) =>
            this.onPortfolioDashboardStoreResponse(actionData)
        );
    }

    public getLastResult(): PortfolioDashboardStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data.filter((ele) => ele.AccountStatus != AccountStatus.InProgress);
    }

    public getFullAccounts() {
        return this.getState().data;
    }

    public getInProgressAccounts() {
        return this.getState().data.filter((ele) => ele.AccountStatus == AccountStatus.InProgress);
    }

    public hasInProgressAccounts() {
        return this.getState().data.some((ele) => ele.AccountStatus == AccountStatus.InProgress);
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): PortfolioDashboardStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: [],
            isLoading: false,
        };
    }

    private onPortfolioDashboardStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
